var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative"},[_c('img',{attrs:{"src":_vm.finalSrc,"alt":"","width":_vm.width}}),_c('span',{staticClass:"text-red absolute",staticStyle:{"top":"-8px","right":"-4px"},on:{"click":_vm.onRemove}},[_c('i',{staticClass:"icon-a-02shanchu"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }